import { render, staticRenderFns } from "./LocalPriceBatch.vue?vue&type=template&id=23867784"
import script from "./LocalPriceBatch.vue?vue&type=script&lang=js"
export * from "./LocalPriceBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports